export default "__VITE_ASSET__C3FnB$Xo__"